var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"object-contain",attrs:{"src":require(("assets/avatars/avatar_" + _vm.getAvatar + ".png")),"alt":_vm.getUsername}})}
var staticRenderFns = []

export { render, staticRenderFns }